var module = angular.module('octopusApp.accounts');

module.directive('azureAccount', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      account: '=model',
      showAdvanced: '=showAdvanced'
    },
    templateUrl: 'areas/accounts/views/azure_account.html',
    link: function(scope) {
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/directives/azure_account.js
// module id = 8652576559329839
// module chunks = 1